import { render } from "./ManufacturerCard.vue?vue&type=template&id=1de0a3db"
import script from "./ManufacturerCard.vue?vue&type=script&lang=js"
export * from "./ManufacturerCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__